import { useRouteMatch } from "react-router-dom";
import * as routes from "@glide/common-core/dist/js/routes";

export function useFolderID(): string | undefined {
    const match = useRouteMatch<{ folderID: string }>(routes.folderPattern);
    return match?.params.folderID;
}
